import { render } from "./AmendBookingJourneySelector.vue?vue&type=template&id=101f8027&scoped=true&lang=pug"
import script from "./AmendBookingJourneySelector.vue?vue&type=script&lang=ts"
export * from "./AmendBookingJourneySelector.vue?vue&type=script&lang=ts"

import "./AmendBookingJourneySelector.vue?vue&type=style&index=0&id=101f8027&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-101f8027"

export default script